import React, { useState } from "react";

import { formatNumericCurrency, useTranslation } from "utils";

import { VESTING_PERCENTAGE, VESTING_YEARS } from "consts";

import { ExtraInfo, LinedCard, LinkMoreInfo, PayoutInVerification, Spin, TimelineStatusLabel } from "components";

// If the payout is partial, preVerificationPayout can be used to show what the total payout would have been
export const PayoutInVerificationCard = ({ loading, className, children, payout, preVerificationPayout, status, year, currency }) => {
  const { t } = useTranslation("modules");
  const [showDrawer, setShowDrawer] = useState();

  const handleOpenDrawer = (e) => {
    e.stopPropagation();
    setShowDrawer(true);
  };

  return (
    <>
      <LinedCard
        className={`payout-card ${className}`}
        dataTestId="payout-in-verification-card"
        primary={
          loading ? (
            <div className="payout-card-content">{<Spin />}</div>
          ) : (
            <>
              <TimelineStatusLabel status={status || "inVerification"} />

              <PayoutInVerification
                payout={payout}
                preVerificationPayout={preVerificationPayout}
                rejected={status === "rejected"}
                caption={t("payoutInVerificationCard.payoutAmount", { year })}
                subCaption={
                  payout !== 0 && (
                    <div className="vesting-info">
                      <LinkMoreInfo onClick={(e) => handleOpenDrawer(e)}>
                        {payout > 0
                          ? t("payoutInVerificationCard.vestingInfo", {
                              payoutNow: formatNumericCurrency((1 - VESTING_PERCENTAGE) * payout, { currency }),
                              payoutVesting: formatNumericCurrency(VESTING_PERCENTAGE * payout, { currency }),
                              year: year + VESTING_YEARS,
                            })
                          : t("payoutInVerificationCard.negativePayout")}
                      </LinkMoreInfo>
                    </div>
                  )
                }
              />
            </>
          )
        }
        secondary={children}
      />

      <ExtraInfo setVisible={setShowDrawer} type={payout > 0 ? "payout-overview" : "negative-payout"} visible={showDrawer} />
    </>
  );
};
